<template lang="pug">
	.upload-amazon-s3(v-if="showed && Project.SelectedProject")
		.card
			.card-header
				i.fa.fa-edit
				span Amazon S3 upload
			.card-body.collapse.show(v-if="state === 'idle'" style="{'flex': '0 1 auto'}")
				.form-horizontal
					.form-group(:class="{'disable-additional-settings': releaseType === 'video'}")
						label.col-form-label(for="project-folder") Template folder
							.controls
								input.form-control(id="project-folder" size="16" type="text" v-model="templateFolder")
						label.col-form-label(for="version-folder") Project folder
							.controls
								input.form-control(id="version-folder" size="16" type="text" v-model="projectFolder")

						.debug-settings
							label.col-form-label(:style="{width: '100px'}") Save folders
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{'background-color': '#343b41'}")
								input.switch-input.form-check-input(type="checkbox" :checked="saveFolders" @change="switchSaveFolders($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
						.two-setting-panel
							.setting-one
								label.col-form-label(for="region") Amazon region
									.controls
										input.form-control.region(id="region" size="16" type="text" v-model="region")
							.setting-two
								label.col-form-label Release type
									.controls.input-group(v-pseudo-modal-show="'release-type-dropdown'")
										span.form-control.release-type {{releaseType}}
										.input-group-append
											span.input-group-text
												i.fa.fa-angle-down
									.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'release-type-dropdown'")
										.dropdown-header(class="text-center")
											strong Choose release type
										NetworkList(:callback="chooseReleaseType" scope="upload")
						.debug-settings.additional-setting
							label.col-form-label(:style="{width: '100px'}") Debug
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{'background-color': '#343b41'}")
								input.switch-input.form-check-input(type="checkbox" :checked="debug" @change="switchDebug($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
						.debug-settings.additional-setting
							label.col-form-label(:style="{width: '100px'}") MOAT Macros
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{'background-color': '#343b41'}")
								input.switch-input.form-check-input(type="checkbox" :checked="moat" @change="switchMOATMacros($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
						.debug-settings.additional-setting
							label.col-form-label(:style="{width: '100px'}") Basis Macros
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{'background-color': '#343b41'}")
								input.switch-input.form-check-input(type="checkbox" :checked="basis" @change="switchBasisMacros($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle

						.debug-settings(:style="{'width': '460px'}").additional-setting
							div.input-wrapper(v-bind:class="{'hidden': !basis}")
								input.form-control(placeholder='basis_var1 basis_var2 basis_var3' v-model="basisVars" :style="{'height': '100%', 'margin-top': '0px'}")

						.debug-settings.additional-setting
							label.col-form-label(:style="{width: '100px'}") HTML Macros
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label(:style="{'background-color': '#343b41'}")
								input.switch-input.form-check-input(type="checkbox" :checked="htmlMacros" @change="switchHTMLMacros($event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle

						.debug-settings(:style="{'width': '460px'}").additional-setting
							div.input-wrapper(v-bind:class="{'hidden': !htmlMacros}")
								input.form-control(placeholder='html_var1 html_var2 html_var3' v-model="htmlMacrosVars" :style="{'height': '100%', 'margin-top': '0px'}")

					.form-result
						span {{previewFileLink}}
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="upload()")
							i.fa.fa-upload
							| &nbsp;&nbsp;Upload
						button.btn.btn-dark(type="button" v-on:click="hide()") Cancel
			.card-body.collapse.show(v-if="state === 'preparing' || state === 'release' || state === 'uploading'")
				.processing
					.icon.fa.fa-spinner.fa-spin
					.text(v-if="state === 'preparing'") preparing...
					.text(v-if="state === 'release'") creating release...
					.text(v-if="state === 'uploading'") uploading...
					.text(v-if="['uploading', 'release'].includes(state) && additionalData") {{additionalData}}
			.card-body.collapse.show(v-if="state === 'result'")
				.result
					.text(v-if="result && result.type === 'tag'")
						textarea {{result.data}}
					.text(v-if="result && result.type === 'file-link'")
						a(v-bind:href="resultFileLink" target="_blank") {{resultTag}}
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="copy()")
							i.fa.fa-copy
							| &nbsp;&nbsp;Copy
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Server } 			from './../../services/Server'

	import { Template } 		from './../../services/Template'
	import { Project } 			from './../../services/Project'
	import { Layout } 			from './../../services/Layout'

	import NetworkList 			from './../Shared/NetworksList'

	import SetupSettings 		from '../../settings/settings'

	export default {
		name: "UploadAmazonS3",
		mixins: [Screen],
		screen: {
			events: {
				"Amazon Upload Progress": function(data) {

					if (data.UploadProjectFolder === 'tampermonkey') this.close();

					if (data.UploadProjectId === Project.SelectedProject.id && data.UploadProjectFolder !== 'tampermonkey') {

						this.state = data.UploadProgress;
						this.additionalData = data.UploadAdditionalData;

						if (data.UploadResult) {

							this.result = data.UploadResult;

						}

						this.update();

						if (data.UploadResult) {

							if (this.result.type === 'tag') {

								this.$nextTick(() => {
									let textArea = document.querySelector('.result > div > textarea');
									if (textArea) textArea.style.height = 25 + textArea.scrollHeight + 'px';
								});

							}
						}

					}

				}
			}
		},
		components: {
			NetworkList
		},
		data() {

			this.Server = Server;
			this.Template = Template;
			this.Project = Project;

			this.result = {};

			this.saveFolders = true;

			return {
				showed: false,
				debug: false,
				moat: false,
				basis: false,
				htmlMacros: false,
				basisVars: '',
				htmlMacrosVars: '',
				state: 'idle', //'preparing', 'release', 'uploading', 'result'
				additionalData: '',
				templateFolder: '',
				projectFolder: '',
				saveFolders: true,
				releaseType: 'js-minified',
				region: 'eu-central-1'
			};

		},
		watch: {
			templateFolder(val) {
				this.templateFolder = this.validateString(val);
			},
			projectFolder(val) {
				this.projectFolder = this.validateString(val);
			},
			basisVars(val) {
				this.basisVars = val;
			},
			htmlMacrosVars(val) {
				this.htmlMacrosVars = val;
			}
		},
		computed: {
			previewFileLink() {
				return `https://cdn.prvk.io/studio/${this.templateFolder}/${this.projectFolder}/`;
			},
			resultFileLink() {
				return `https://cdn.prvk.io/studio/${this.result.templateFolder}/${this.result.projectFolder}/${this.result.data}`;
			},
			resultTag() {
				return `<script src="${this.resultFileLink}" async>`;
			}
		},
		methods: {
			collectData(eventName) {

				if (eventName === 'show') this.state = 'idle';

				let selectedProject = Project.SelectedProject;

				if (!selectedProject) return;

				if (!selectedProject.AdditionalData) selectedProject.AdditionalData = {};

				let templateFolder = Template.SelectedTemplate ? Template.SelectedTemplate.codename : '';
				if (selectedProject && selectedProject.AdditionalData && selectedProject.AdditionalData.templateFolder) {
					templateFolder = selectedProject.AdditionalData.templateFolder;
				}
				if (selectedProject && this.releaseType === 'video' && selectedProject.AdditionalData && selectedProject.AdditionalData.templateFolderVideo) {
					templateFolder = selectedProject.AdditionalData.templateFolderVideo;
				}
				let projectFolder = Project.SelectedProject ? Project.SelectedProject.id : this.releaseType;
				if (selectedProject && selectedProject.AdditionalData && selectedProject.AdditionalData.projectFolder) {
					projectFolder = selectedProject.AdditionalData.projectFolder;
				}
				if (selectedProject && this.releaseType === 'video' && selectedProject.AdditionalData && selectedProject.AdditionalData.projectFolderVideo) {
					projectFolder = selectedProject.AdditionalData.projectFolderVideo;
				}

				this.templateFolder = templateFolder;
				this.projectFolder = projectFolder;

				if (this.releaseType === 'video') {
					if (!selectedProject.AdditionalData.templateFolderVideo) this.templateFolder += '-video';
					if (!selectedProject.AdditionalData.projectFolderVideo) this.projectFolder += '-video';
				}

				this.region = Server.Config['amazon-s3-bucket-region'] || 'eu-central-1';

				this.saveFolders = true;
				this.debug = false;
				this.moat = false;
				this.basis = false;
				this.htmlMacros = false;
				this.basisVars = '';
				this.htmlMacrosVars = '';

			},
			upload() {

				let templateFolder = this.templateFolder;
				let projectFolder = this.projectFolder;
				let basisVars = this.basisVars;
				let htmlMacrosVars = this.htmlMacrosVars;

				if (templateFolder === '') {
					templateFolder = Template.SelectedTemplate ? Template.SelectedTemplate.codename : 'template';
					if (this.releaseType === 'video') templateFolder += '-video';
				}
				if (projectFolder === '') {
					projectFolder = Project.SelectedProject ? Project.SelectedProject.id : this.releaseType;
					if (this.releaseType === 'video') projectFolder += '-video';
				}

				if (this.releaseType === 'video') {

					Broadcast.call("Show Download Video", [{
						scope: 'upload',
						uploadTo: 'amazon',
						projectId: Project.SelectedProject.id,
						releaseType: this.releaseType,
						templateFolder,
						projectFolder,
						region: this.region,
						saveFolders: this.saveFolders
					}]);

					this.close();

					return;

				}

				Server.sendToSocket({
					UploadCreative: {
						uploadTo: 'amazon',
						projectId: Project.SelectedProject.id,
						releaseType: this.releaseType,
						debug: this.debug,
						moat: this.moat,
						basis: this.basis,
						htmlMacros: this.htmlMacros,
						saveFolders: this.saveFolders,
						templateFolder: templateFolder,
						projectFolder: projectFolder,
						basisVars: basisVars,
						htmlMacrosVars: htmlMacrosVars,
						region: this.region
					}
				});

				this.state = 'preparing';

			},
			chooseReleaseType(type) {

				this.releaseType = type;

				if (this.releaseType === 'video') {
					this.debug = false;
					this.moat = false;
					this.basis = false;
					this.htmlMacros = false;
				}

				this.collectData('chooseReleaseType');

				Broadcast.call("Pseudo Modal Hide", ['release-type-dropdown']);

			},

			switchDebug(value) {
				this.debug = value;
			},
			switchMOATMacros(value) {
				this.moat = value;
			},
			switchBasisMacros(value) {
				this.basis = value;
			},
			switchHTMLMacros(value) {
				this.htmlMacros = value;
			},
			switchSaveFolders(value) {
				this.saveFolders = value;
			},

			validateString(string) {
				return string.toString().replaceAll(/[^a-zA-Z0-9-_]/g, '');
			},

			copy() {

				let text = '';

				if (this.result) {
					if (this.result.type === 'tag') text = this.result.data;
					else if (this.result.type === 'file-link') text = this.resultTag;
				}

				Layout.copyTextToClipboard(text);

			},
			close() {

				this.state = 'idle';

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.upload-amazon-s3
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: fit-content
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.input-wrapper
				overflow: hidden
				transition: 0.15s
				height: calc(1.5em + 0.75rem + 2px)

			.hidden
				height: 0px


			input
				width: 460px
				margin-top: 5px

				&::placeholder
					color: rgba(255, 255, 255, 0.1)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: relative
				width: calc(100% - 40px)
				margin-top: 5px

			.form-control.release-type
				cursor: pointer
				width: 150px
				margin-top: 5px
				user-select: none

			.input-group-append
				margin-top: 5px
				cursor: pointer

				.input-group-text
					background-color: #343b41
					border: 1px solid #23282c
					color: #e4e7ea

		.two-setting-panel
			display: flex
			flex-direction: row
			justify-content: space-between

			.setting-one

				.form-control.region
					width: 200px

		.disable-additional-settings > .debug-settings.additional-setting
			opacity: 0.5
			cursor: not-allowed

			.switch, .switch-slider
				pointer-events: none

		.debug-settings
			display: flex
			flex-direction: row
			color: #e4e7ea
			align-items: center

			.switch-slider
				background-color: #3a4149

		.form-result
			color: #20a8d8
			font-size: 11px

		.dropdown-menu
			position: absolute
			right: -230px
			top: auto
			bottom: 114px
			display: block
			z-index: 10000
			line-height: 1.5
			width: 250px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

			.dropdown-header
				cursor: default

			.networks
				height: 197px
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 250px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

		.processing
			height: 100%
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center

			.icon
				display: inline
				font-size: 30px

		.result

			textarea
				max-height: 800px
				width: 100%
				height: 250px
				background: transparent
				border: none
				color: #fff
				font-size: 12px
				white-space: pre
				overflow-wrap: normal
				overflow-x: auto
</style>

